import { createStore } from 'vuex'

import modals from './modules/modals'
import notifications from './modules/notifications'
import sound from './modules/sound'
import socket from './modules/socket'
import auth from './modules/auth'
import general from './modules/general'
import user from './modules/user'
import chat from './modules/chat'
import rain from './modules/rain'
import crash from './modules/crash'
import roll from './modules/roll'
import blackjack from './modules/blackjack'
import duels from './modules/duels'
import mines from './modules/mines'
import towers from './modules/towers'
import unbox from './modules/unbox'
import battles from './modules/battles'
import upgrader from './modules/upgrader'
import settings from './modules/settings'
import cashier from './modules/cashier'
import rakeback from './modules/rakeback'
import affiliates from './modules/affiliates'
import leaderboard from './modules/leaderboard'
import jackpot from './modules/jackpot'
import admin from './modules/admin'
import spin from './modules/spin'
import vip from './modules/vip'
import futures from './modules/futures'
import crypto from './modules/crypto'

const store = createStore({
  modules: {
    modals,
    notifications,
    sound,
    socket,
    auth,
    general,
    settings,
    crypto,
    user,
    chat,
    rain,
    futures,
    crash,
    roll,
    blackjack,
    duels,
    mines,
    towers,
    unbox,
    battles,
    upgrader,
    cashier,
    rakeback,
    affiliates,
    leaderboard,
    jackpot,
    admin,
    vip,
    spin
  }
})

export default store
